import styled from 'styled-components';

export const SearchFiltersHeaderHolder = styled.div`
  align-self: center;
  flex: 0 0 84px;
`;
